import { CouplePatientAPI, GroupPatientAPI, type GroupPatient, listAllTherapistPatientsResponse } from "../../patient";
import { SystemicMapAPI } from "../infrastructure/api/SystemicMap.api";

/**
 * The therapist's caseload the map list can be filtered by: their individual
 * patients (first 100), couples and groups. A failing group list counts as no
 * groups; any other failure rejects.
 */
export async function loadMapSubjectCaseload(therapistId: string) {
    const [individuals, couples, groups] = await Promise.all([
        listAllTherapistPatientsResponse(therapistId),
        CouplePatientAPI.listByTherapist(therapistId),
        GroupPatientAPI.list().catch(() => ({ data: [] as GroupPatient[] })),
    ]);
    return { patients: individuals.data.patients, couples: couples.data, groups: groups.data };
}

export async function listSystemicMaps(params?: Parameters<typeof SystemicMapAPI.list>[0]) {
    const { data } = await SystemicMapAPI.list(params);
    return data;
}

export async function createSystemicMap(payload: Parameters<typeof SystemicMapAPI.create>[0]) {
    const { data } = await SystemicMapAPI.create(payload);
    return data;
}

export async function renameSystemicMap(mapId: string, title: string) {
    const { data } = await SystemicMapAPI.rename(mapId, title);
    return data;
}

export async function removeSystemicMap(mapId: string): Promise<void> {
    await SystemicMapAPI.remove(mapId);
}
